import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import KioskHeader from './kioskComponents/KioskHeader';
import { useNavigate } from 'react-router-dom';

import BACKGROUND_IMG from '../../images/home_body.png';

// ─────────────────────────────────────────────
// Kiosk screen: 1080px × 1920px (portrait 21")
// ─────────────────────────────────────────────

const BodySection = styled(Box)({
  flex: 1,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingBottom: '350px'
});

const BgImage = styled('img')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  zIndex: 0
});

const ContentBox = styled(Box)({
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: '0 80px'
});

const ActionButton = styled(Button)({
  marginTop: '360px',
  borderRadius: '10px',
  textTransform: 'none',
  letterSpacing: '0.02em',
  color: '#FFF4E2',
  background: 'linear-gradient(180deg, #FC9000 0%, #FC4800 100%)',
  boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.45)',
  border: '3px solid #FFF4E2',
  transition: 'transform 0.15s, box-shadow 0.15s',
  '&:hover': {
    background: 'linear-gradient(160deg, #FC9000 0%, #FC4800 100%)',
    transform: 'scale(1.0)',
    boxShadow: '0px 10px 40px rgba(0,0,0,0.55)',
    border: '3px solid #fff'
  },
  '&:active': {
    transform: 'scale(0.97)'
  }
});

const TempleLandingPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#000',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          width: '1080px',
          height: '1920px',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: '#000'
        }}
      >
        {/* ── Top Header — now using shared KioskHeader ── */}
        <KioskHeader />

        {/* ── Body: Background + Overlay + Text ── */}
        <BodySection>
          <BgImage src={BACKGROUND_IMG} alt="Temple" />

          <ContentBox>
            <Typography
              component="h1"
              sx={{
                fontWeight: 600,
                fontSize: '40px',
                color: '#FFF8A6',
                textShadow: '2px 2px 8px rgba(0,0,0,0.6)',
                lineHeight: 1, WebkitTextStroke: "0.3px #FF7A28",
              }}
            >
              Welcome to
              <br />
              Sri Venkateswara Temple
            </Typography>

            <ActionButton variant="h4" disableElevation onClick={() => navigate("/kiosk/landing")} sx={{
              fontWeight: 600, padding: "10px 46px",
              fontSize: '22px',
            }}>
              Start Order
            </ActionButton>
          </ContentBox>
        </BodySection>
      </Box>
    </Box>
  );
};

export default TempleLandingPage;
